
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/[category]",
      function () {
        return require("private-next-pages/[lang]/[category]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/[category]"])
      });
    }
  